import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormArray, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal, NgbDate, NgbDatepickerModule, NgbDateStruct, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ConsignmentsPopupmodalComponent } from '../consignments-popupmodal/consignments-popupmodal.component';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { TranslationService } from '@spartacus/core';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-consignments-confirm-bid-popup',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule,
      CommonModule,
      FormsModule,
      ReactiveFormsModule,NgbModule,
      NgbDatepickerModule,
      NgSelectModule,],
  templateUrl: './consignments-confirm-bid-popup.component.html',
  styleUrl: './consignments-confirm-bid-popup.component.scss'
})
export class ConsignmentsConfirmBidPopupComponent implements OnInit {
  @Input() consignForm!:FormGroup;
  @Input() selectedMaterials!:any
  @Input() shipTo!:any;
  @Input() timezone!:any
  @Input() buyerRemarks:string
  @Input() popup:string
  @Input() orderCode:string
  @Input() bidChannel:string
  ValidityDate:NgbDate
  deliveryDate:NgbDate
    convertedDate: any
    Remark:any;
    subconvertedDate:any;
    subconvertedDeliveryDate:any;
date:any;
deliveryconvertedDate:any;
deliverydate:any;
list:any[]=[]
priceArray:any;
  enableLoader:boolean
  constructor(private route: ActivatedRoute,private router: Router,public cd: ChangeDetectorRef,public translation: TranslationService,public toastrService: ToastrService,
    public customprofile: CustomProfileService,public ActiveModal: NgbActiveModal,public modalService: NgbModal) {
  }
  ngOnInit(): void {
    const form=this.customprofile.getCurrentBidForm();
    if(form){
      this.consignForm=form
    }
    this.ValidityDate=this.consignForm.get('ValidityDate')?.value;
    this.deliveryDate=this.consignForm.get('deliveryDate')?.value;
    this.priceArray=this.consignForm.get('priceList') as FormArray;
    this.list=this.priceArray?this.priceArray.getRawValue():[];
    console.log(this.list)
     this.cd.detectChanges();
    if (this.ValidityDate ) {
      this.subconvertedDate = this.formatDate(this.ValidityDate)
    }
    if (this.deliveryDate) {
      this.subconvertedDeliveryDate =this.formatDate(this.deliveryDate)
    }
    this.Remark = this.buyerRemarks;
   
  }
  formatDate(date:any){
    if(date && date.year && date.month && date.day)
return  date.day +
        '/' +
        this.checkPad(date.month) +
        '/' +
        this.checkPad(date.year);
  }
  closeModal(status) {
    this.ActiveModal.close(status);
    this.customprofile.clearBidForm();
  }
  backToplaceOrder(){
      const ModalRef = this.modalService.open(ConsignmentsPopupmodalComponent, { centered: true, size: 'md' });
      ModalRef.componentInstance.consignForm = this.consignForm.value;
      ModalRef.componentInstance.buyerRemarks = this.Remark;
      ModalRef.componentInstance.orderCode = this.orderCode;
      ModalRef.componentInstance.popUp = this.popup;
      ModalRef.componentInstance.bidChannel = this.bidChannel;
      this.ActiveModal.close({
        form:this.consignForm,
        material:this.selectedMaterials
      }) 
}
saveConsignmentOrder(){
   const timeSelected=this.consignForm.get('ValidityTime')?.value;
  if (this.ValidityDate != null) {
          this.convertedDate = this.ValidityDate.year+'-'+this.checkPad(this.ValidityDate.month)+'-'+this.checkPad(this.ValidityDate.day);
          const dateTime = moment(this.convertedDate + ' ' +timeSelected, 'YYYY-MM-DD HH:mm');
          this.date = dateTime.format();
        }
        if (this.deliveryDate != null) {
          this.deliveryconvertedDate = this.deliveryDate.year+'-'+this.checkPad(this.deliveryDate.month)+'-'+this.checkPad(this.deliveryDate.day);
         const dateTime = moment(this.deliveryconvertedDate + ' ' +timeSelected, 'YYYY-MM-DD HH:mm');
          this.deliverydate = dateTime.format();

        }
        let NoAmountList = this.list?.filter(element => !(element.kopPriceAmount === '' || element.kopPriceAmount == null || element.kopPriceAmount==0));
    let SaveObject = {
      "quoteTemplate": {
        // "ctcontractTemplateId": ""
      },
      "validity": '',
      "remark": this.Remark,
      "quoteEntryRequest": [
        {
          "quantityInDecimal": this.consignForm.get('quantity')?.value,
          "productCode": this.consignForm.get('productCode')?.value,
          "basePrice": this.consignForm.get('basePrice')?.value,
          "priceList": NoAmountList||[],
          "shipTo":this.consignForm.get('shipTo')?.value,
          "extRefNo": this.consignForm.get('extRefNo')?.value,
}

      ],
      "deliveryDate": this.deliverydate,
      "timeZone":'',
      "quoteAction":this.popup=='Edit Order'?'BID_PLACED':null,
      "quoteCode":this.popup=='Edit Order'? this.orderCode:null,
      "bidChannel":this.popup=='Edit Order'?this.bidChannel=='STOREFRONT'?'STOREFRONT':'BACKOFFICE':null

    }
    SaveObject.quoteEntryRequest.forEach((element: any) => {
      element.priceList.forEach((price: any) => {
        if(price.kopPriceSymbol == '%'){
           price.kopPricePercentage = price.kopPriceAmount
           delete price.kopPriceAmount;
        }
        else{
          delete price.kopPricePercentage;
        }
      })
    });
    this.enableLoader = true;
    let toastshown = false;
    this.customprofile.saveConsignmentPlaceOrder(SaveObject).subscribe({
      next: (response: any) => {
        if (response?.status === 'BID_PLACED') {
          this.enableLoader = false;
          this.closeModal('sucess')
          
          this.customprofile.clearBidForm()
        }
        else {
          this.enableLoader = false;
          this.closeModal('error')
          this.toastrService.show(response?.status || 'Error while placing an order, please contact support team');
            
        }
      },
      error: (err) => {
        this.enableLoader = false;
        this.closeModal('error')
        this.toastrService.show('Error while placing an order, please contact support team');
      }
    })
 

}
checkPad(d){
    return (d < 10) ? '0' + d.toString() : d.toString();
  }
}
